"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _excluded = ["width", "height", "viewBox", "fill", "title"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var YoutubeLogo = function YoutubeLogo(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? 30 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 22 : _ref$height,
    _ref$viewBox = _ref.viewBox,
    viewBox = _ref$viewBox === void 0 ? "0 0 35 27" : _ref$viewBox,
    _ref$fill = _ref.fill,
    fill = _ref$fill === void 0 ? "#fffffe" : _ref$fill,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? "Youtube Logo" : _ref$title,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    width: width,
    height: height,
    viewBox: viewBox
  }, rest), /*#__PURE__*/_react["default"].createElement("title", null, title), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M13.92 19.2V7.8l9.15 5.7-9.15 5.7zM34.27 4.22A4.63 4.63 0 0 0 31.17.8C28.44 0 17.5 0 17.5 0S6.56 0 3.83.8a4.63 4.63 0 0 0-3.1 3.42C0 7.22 0 13.5 0 13.5s0 6.28.73 9.28a4.63 4.63 0 0 0 3.1 3.41C6.56 27 17.5 27 17.5 27s10.94 0 13.67-.8a4.63 4.63 0 0 0 3.1-3.42c.73-3 .73-9.28.73-9.28s0-6.28-.73-9.28z"
  }));
};
var _default = exports["default"] = YoutubeLogo;